/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApplyWorkOrderMergeRequestDto,
  AssignWorkOrderRequestDto,
  CancelWorkOrderRequestDto,
  CompleteWorkOrderRequestDto,
  CompleteWorkOrderResponseDto,
  HoldWorkOrderRequestDto,
  MoveTicketRequestDto,
  WorkOrderBoardResponseDto,
  WorkOrderDetailDto,
  WorkOrderMergeSuggestionsResponseDto,
} from '../models/index';
import {
    ApplyWorkOrderMergeRequestDtoFromJSON,
    ApplyWorkOrderMergeRequestDtoToJSON,
    AssignWorkOrderRequestDtoFromJSON,
    AssignWorkOrderRequestDtoToJSON,
    CancelWorkOrderRequestDtoFromJSON,
    CancelWorkOrderRequestDtoToJSON,
    CompleteWorkOrderRequestDtoFromJSON,
    CompleteWorkOrderRequestDtoToJSON,
    CompleteWorkOrderResponseDtoFromJSON,
    CompleteWorkOrderResponseDtoToJSON,
    HoldWorkOrderRequestDtoFromJSON,
    HoldWorkOrderRequestDtoToJSON,
    MoveTicketRequestDtoFromJSON,
    MoveTicketRequestDtoToJSON,
    WorkOrderBoardResponseDtoFromJSON,
    WorkOrderBoardResponseDtoToJSON,
    WorkOrderDetailDtoFromJSON,
    WorkOrderDetailDtoToJSON,
    WorkOrderMergeSuggestionsResponseDtoFromJSON,
    WorkOrderMergeSuggestionsResponseDtoToJSON,
} from '../models/index';

export interface WorkOrderControllerApplyMergeRequest {
    applyWorkOrderMergeRequestDto: ApplyWorkOrderMergeRequestDto;
    organizationId?: string;
}

export interface WorkOrderControllerAssignRequest {
    id: string;
    assignWorkOrderRequestDto: AssignWorkOrderRequestDto;
    organizationId?: string;
}

export interface WorkOrderControllerCancelRequest {
    id: string;
    cancelWorkOrderRequestDto: CancelWorkOrderRequestDto;
    organizationId?: string;
}

export interface WorkOrderControllerCloseInterventionRequest {
    ticketId: string;
    id: string;
    organizationId?: string;
}

export interface WorkOrderControllerCloseWorkOrderRequest {
    id: string;
    organizationId?: string;
}

export interface WorkOrderControllerCompleteRequest {
    id: string;
    completeWorkOrderRequestDto: CompleteWorkOrderRequestDto;
    organizationId?: string;
}

export interface WorkOrderControllerGetBoardRequest {
    includeTerminal?: boolean;
    organizationId?: string;
}

export interface WorkOrderControllerGetByIdRequest {
    id: string;
    organizationId?: string;
}

export interface WorkOrderControllerGetMergeSuggestionsRequest {
    status?: Array<any>;
    scheduledTo?: string;
    scheduledFrom?: string;
    isoWeekKey?: string;
    siteId?: string;
    limit?: number;
    page?: number;
    organizationId?: string;
}

export interface WorkOrderControllerHoldRequest {
    id: string;
    holdWorkOrderRequestDto: HoldWorkOrderRequestDto;
    organizationId?: string;
}

export interface WorkOrderControllerMoveTicketRequest {
    ticketId: string;
    id: string;
    moveTicketRequestDto: MoveTicketRequestDto;
    organizationId?: string;
}

export interface WorkOrderControllerStartRequest {
    id: string;
    organizationId?: string;
}

/**
 * 
 */
export class MaintenanceExecutionWorkOrdersApi extends runtime.BaseAPI {

    /**
     */
    async workOrderControllerApplyMergeRaw(requestParameters: WorkOrderControllerApplyMergeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['applyWorkOrderMergeRequestDto'] == null) {
            throw new runtime.RequiredError(
                'applyWorkOrderMergeRequestDto',
                'Required parameter "applyWorkOrderMergeRequestDto" was null or undefined when calling workOrderControllerApplyMerge().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/work-orders/optimizer/apply-merge`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApplyWorkOrderMergeRequestDtoToJSON(requestParameters['applyWorkOrderMergeRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async workOrderControllerApplyMerge(requestParameters: WorkOrderControllerApplyMergeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.workOrderControllerApplyMergeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async workOrderControllerAssignRaw(requestParameters: WorkOrderControllerAssignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling workOrderControllerAssign().'
            );
        }

        if (requestParameters['assignWorkOrderRequestDto'] == null) {
            throw new runtime.RequiredError(
                'assignWorkOrderRequestDto',
                'Required parameter "assignWorkOrderRequestDto" was null or undefined when calling workOrderControllerAssign().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/work-orders/{id}/assign`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssignWorkOrderRequestDtoToJSON(requestParameters['assignWorkOrderRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async workOrderControllerAssign(requestParameters: WorkOrderControllerAssignRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.workOrderControllerAssignRaw(requestParameters, initOverrides);
    }

    /**
     */
    async workOrderControllerCancelRaw(requestParameters: WorkOrderControllerCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling workOrderControllerCancel().'
            );
        }

        if (requestParameters['cancelWorkOrderRequestDto'] == null) {
            throw new runtime.RequiredError(
                'cancelWorkOrderRequestDto',
                'Required parameter "cancelWorkOrderRequestDto" was null or undefined when calling workOrderControllerCancel().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/work-orders/{id}/cancel`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancelWorkOrderRequestDtoToJSON(requestParameters['cancelWorkOrderRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async workOrderControllerCancel(requestParameters: WorkOrderControllerCancelRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.workOrderControllerCancelRaw(requestParameters, initOverrides);
    }

    /**
     */
    async workOrderControllerCloseInterventionRaw(requestParameters: WorkOrderControllerCloseInterventionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['ticketId'] == null) {
            throw new runtime.RequiredError(
                'ticketId',
                'Required parameter "ticketId" was null or undefined when calling workOrderControllerCloseIntervention().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling workOrderControllerCloseIntervention().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/work-orders/{id}/tickets/{ticketId}/close`;
        urlPath = urlPath.replace(`{${"ticketId"}}`, encodeURIComponent(String(requestParameters['ticketId'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async workOrderControllerCloseIntervention(requestParameters: WorkOrderControllerCloseInterventionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.workOrderControllerCloseInterventionRaw(requestParameters, initOverrides);
    }

    /**
     */
    async workOrderControllerCloseWorkOrderRaw(requestParameters: WorkOrderControllerCloseWorkOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling workOrderControllerCloseWorkOrder().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/work-orders/{id}/close`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async workOrderControllerCloseWorkOrder(requestParameters: WorkOrderControllerCloseWorkOrderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.workOrderControllerCloseWorkOrderRaw(requestParameters, initOverrides);
    }

    /**
     */
    async workOrderControllerCompleteRaw(requestParameters: WorkOrderControllerCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompleteWorkOrderResponseDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling workOrderControllerComplete().'
            );
        }

        if (requestParameters['completeWorkOrderRequestDto'] == null) {
            throw new runtime.RequiredError(
                'completeWorkOrderRequestDto',
                'Required parameter "completeWorkOrderRequestDto" was null or undefined when calling workOrderControllerComplete().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/work-orders/{id}/complete`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteWorkOrderRequestDtoToJSON(requestParameters['completeWorkOrderRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompleteWorkOrderResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async workOrderControllerComplete(requestParameters: WorkOrderControllerCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompleteWorkOrderResponseDto> {
        const response = await this.workOrderControllerCompleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async workOrderControllerGetBoardRaw(requestParameters: WorkOrderControllerGetBoardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkOrderBoardResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['includeTerminal'] != null) {
            queryParameters['includeTerminal'] = requestParameters['includeTerminal'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/work-orders/board`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkOrderBoardResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async workOrderControllerGetBoard(requestParameters: WorkOrderControllerGetBoardRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkOrderBoardResponseDto> {
        const response = await this.workOrderControllerGetBoardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async workOrderControllerGetByIdRaw(requestParameters: WorkOrderControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkOrderDetailDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling workOrderControllerGetById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/work-orders/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkOrderDetailDtoFromJSON(jsonValue));
    }

    /**
     */
    async workOrderControllerGetById(requestParameters: WorkOrderControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkOrderDetailDto> {
        const response = await this.workOrderControllerGetByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async workOrderControllerGetMergeSuggestionsRaw(requestParameters: WorkOrderControllerGetMergeSuggestionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkOrderMergeSuggestionsResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['scheduledTo'] != null) {
            queryParameters['scheduledTo'] = requestParameters['scheduledTo'];
        }

        if (requestParameters['scheduledFrom'] != null) {
            queryParameters['scheduledFrom'] = requestParameters['scheduledFrom'];
        }

        if (requestParameters['isoWeekKey'] != null) {
            queryParameters['isoWeekKey'] = requestParameters['isoWeekKey'];
        }

        if (requestParameters['siteId'] != null) {
            queryParameters['siteId'] = requestParameters['siteId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/work-orders/optimizer/suggestions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkOrderMergeSuggestionsResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async workOrderControllerGetMergeSuggestions(requestParameters: WorkOrderControllerGetMergeSuggestionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkOrderMergeSuggestionsResponseDto> {
        const response = await this.workOrderControllerGetMergeSuggestionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async workOrderControllerHoldRaw(requestParameters: WorkOrderControllerHoldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling workOrderControllerHold().'
            );
        }

        if (requestParameters['holdWorkOrderRequestDto'] == null) {
            throw new runtime.RequiredError(
                'holdWorkOrderRequestDto',
                'Required parameter "holdWorkOrderRequestDto" was null or undefined when calling workOrderControllerHold().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/work-orders/{id}/hold`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HoldWorkOrderRequestDtoToJSON(requestParameters['holdWorkOrderRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async workOrderControllerHold(requestParameters: WorkOrderControllerHoldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.workOrderControllerHoldRaw(requestParameters, initOverrides);
    }

    /**
     */
    async workOrderControllerMoveTicketRaw(requestParameters: WorkOrderControllerMoveTicketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['ticketId'] == null) {
            throw new runtime.RequiredError(
                'ticketId',
                'Required parameter "ticketId" was null or undefined when calling workOrderControllerMoveTicket().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling workOrderControllerMoveTicket().'
            );
        }

        if (requestParameters['moveTicketRequestDto'] == null) {
            throw new runtime.RequiredError(
                'moveTicketRequestDto',
                'Required parameter "moveTicketRequestDto" was null or undefined when calling workOrderControllerMoveTicket().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/work-orders/{id}/tickets/{ticketId}/move`;
        urlPath = urlPath.replace(`{${"ticketId"}}`, encodeURIComponent(String(requestParameters['ticketId'])));
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MoveTicketRequestDtoToJSON(requestParameters['moveTicketRequestDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async workOrderControllerMoveTicket(requestParameters: WorkOrderControllerMoveTicketRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.workOrderControllerMoveTicketRaw(requestParameters, initOverrides);
    }

    /**
     */
    async workOrderControllerStartRaw(requestParameters: WorkOrderControllerStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling workOrderControllerStart().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['organizationId'] != null) {
            queryParameters['organizationId'] = requestParameters['organizationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/v1/work-orders/{id}/start`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async workOrderControllerStart(requestParameters: WorkOrderControllerStartRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.workOrderControllerStartRaw(requestParameters, initOverrides);
    }

}
